import React from "react";

type Props = {
  src: string;
  alt?: string;
  background?: string;
  padding?: number;
  style?: React.CSSProperties;
  onClick?: () => void;
  shadow?: boolean;
  borderRadius?: number;
};

export default function HighLogo({
  src,
  alt = "logo",
  background = "transparent",
  padding = 0,
  style,
  onClick,
  shadow = false,
  borderRadius = 16,
}: Props) {
  return (
    <div
      role="img"
      aria-label={alt}
      style={{
        display: "inline-block",
        background,
        borderRadius,
        padding,
        userSelect: "none",
        ...style,
      }}
    >
      <img
        src={src}
        alt={alt}
        onClick={onClick}
        draggable={false}
        style={{
          display: "block",
          width: "100%",
          marginLeft: '25px',
          marginTop: '-6px',
          height: "auto",
          cursor: onClick ? "pointer" : "default",
          borderRadius,
          filter: shadow
            ? "drop-shadow(0px 6px 12px rgba(0,0,0,0.35))"
            : "none",
        }}
      />
    </div>
  );
}
